import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Route, Routes, useLocation } from 'react-router-dom';
import Altova from './components/Altova';
import Course from './components/course/Course';
import Home from './components/home/Home';
import CourseTileContainer from './components/tiles/CourseTileContainer';
import CategoryTileContainer from './components/tiles/CategoryTileContainer';
import ContactUsPage from './components/contact/ContactUsPage';
import Consulting from './components/consulting/Consulting';
import About from './components/about/About';
import EdTech from './components/edtech/EdTech';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import Accreditations from './components/accreditations/Accreditations';
import { CoursesProvider } from './context/CoursesContext';
import { PrivacyPolicy } from './components/policies';
import { HelmetProvider } from 'react-helmet-async';
import './assets/css/watchelm.scss';

function App() {
  const location = useLocation();

  // Define header props for each route
  const headerProps = {
    '/': { title: 'WE <strong>Excel</strong> Together.', strapline: 'Empower your teams with leading tech training, giving them the foundation to thrive.', background: "home" },
    '/training': { title: 'WE <strong>Excel</strong> Together.', strapline: 'Empower your teams with leading tech training, giving them the foundation to thrive.', background: "training" },
    '/altova': { title: 'Altova Training and Consulting', strapline: 'We are an Altova Training and Consulting Partner.' },
    '/contact': { title: 'Contact Us', strapline: 'We&apos;d love to hear from you!' },
    '/about': { title: 'WE Solve Together', strapline: 'Solving business problems using our high-quality training, consulting, and EdTech services.' },
    '/privacy-policy': { title: 'Privacy Policy', strapline: 'How we protect and manage your data' },
    '/edtech': { title: 'EdTech Solutions', strapline: 'Automating your technology requirements for education providers.' },
    '/consulting': { title: 'WE Solve Together', strapline: 'Turning AI and Cloud complexity into competitive advantage.' },
  };

  let currentHeaderProps = headerProps[location.pathname] || { title: '', strapline: '' };

  // Helper function to format titles (capitalize words and handle special cases)
  const formatTitle = (title) => {
    return decodeURIComponent(title)
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Check if we're on a categories page
  if (location.pathname.startsWith('/categories/')) {
    const encodedCategoryName = location.pathname.split('/categories/')[1];
    const formattedCategory = formatTitle(encodedCategoryName);
    currentHeaderProps = {
      title: formattedCategory,
      strapline: `Explore our ${formattedCategory} courses and training programs.`,
      background: "training"
    };
  }
  // Check if we're on a course details page
  else if (location.pathname.startsWith('/course/')) {
    const pathSegments = location.pathname.split('/');
    if (pathSegments.length >= 4) {
      const encodedCourseTitle = pathSegments.slice(3).join('/');
      const formattedCourseTitle = formatTitle(encodedCourseTitle);
      currentHeaderProps = {
        title: formattedCourseTitle,
        strapline: `Outline`,
        background: "training"
      };
    }
  }

  return (
    <>
      <HelmetProvider>
        <CoursesProvider>
          <ScrollToTop />
          <Header {...currentHeaderProps} />
          <div className="App">
            <Routes>
              <Route path="/altova" element={<Altova />} />
              <Route path="/categories/:category" element={<CourseTileContainer />} />
              <Route path="/course/:code/:title" element={<Course />} />
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<ContactUsPage />} />
              <Route path="/consulting" element={<Consulting />} />
              <Route path="/about" element={<About />} />
              <Route path="/edtech" element={<EdTech />} />
              <Route path="/training" element={<CategoryTileContainer />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
            <Footer />
            <Accreditations />
          </div>
        </CoursesProvider>
      </HelmetProvider>
    </>
  );
}

export default App;